<template>
  <div class="main-users-container">
    <div class="users-top-viki-and-charts-container">
      <UsersTopLeftChartsContainer></UsersTopLeftChartsContainer>
      <notifications></notifications>
      <UsersTopRightChartsContainer></UsersTopRightChartsContainer>
    </div>
    <div class="middle-section-users-table">
      <users-table></users-table>
    </div>
    <div class="bottom-section-users-table">
      <left-bottom-chart></left-bottom-chart>
      <div class="tempLikeViki">
        <general-live-stats-sub-chart />
      </div>
      <security-cams></security-cams>
      <right-bottom-chart></right-bottom-chart>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
import UsersTable from "../containers/UsersTable.container";
import UsersTopLeftChartsContainer from "../charts.sub_featue.users/containers/UsersTopLeftChartsContainer";
import UsersTopRightChartsContainer from "../charts.sub_featue.users/containers/UsersTopRightChartsContainer";
import LeftBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/LeftBottomChart.container";
import RightBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/RightBottomChart.container";
import SecurityCams from "../../security.feature/containers/SecurityCams.container";
import GeneralLiveStatsSubChart from "../../company.feature/sub_features.company/graph.sub-feature.company/components/GeneralLiveStatsSubChart.component";
// import CalendarsDashboard
//   from "../../company.feature/sub_features.company/clients_table.sub_feature.company/components/date_range_filtering_dashboard_v4/CalendarsDashboard";

export default {
  name: "Users.container",
  components: {
    Notifications,
    UsersTable,
    UsersTopLeftChartsContainer,
    UsersTopRightChartsContainer,
    LeftBottomChart,
    RightBottomChart,
    SecurityCams,
    GeneralLiveStatsSubChart
  },
  computed: {
    ...mapState("clients", [
      "tabsList",
      "mainTabsList",
      "usersTabs",
      "brokersTabs",
      "salesPersonList",
      "dictionaries",
      "enlargeCompanyTable",
      "chartsViewBlocks"
    ]),
    ...mapActions("clients", [
      "getActivityDictionary",
      "getGeneralDictionary",
      "getSalesPersonList"
    ])
  },

  mounted() {},
  data() {
    return {};
  }
};
</script>

<style scoped>
.users-top-viki-and-charts-container {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.bottom-section-users-table {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  max-height: 100%;
}
</style>
